import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
//import { adminGetUsers } from '@services/users.service';
import { NavLink } from "react-router-dom";
//import moment from 'moment';
import { useNavigate } from "react-router-dom";
import FilterForm from "@components/common/AddFilter/FilterForm";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import DataTable from "@components/DataTable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import ScrollableReactTable from "@components/ScrollableDatatable";
import {
  createSupportTicket,
  exportSupport,
  getSupportList,
  getUserGuideList,
} from "@services/support.service";
import { concatString, formatText } from "@_common/format-text";
import SupportAddPopup from "../Add/OpenDetails";
import SimpleReactValidator from "simple-react-validator";
import { currentDate } from "@_common/date-helpers";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { handleDownloadOnClick } from "@_common/downloadfile";
import DocumentSvgComponent from "../../../assets/svg-components/document";
import VideoSvgComponent from "../../../assets/svg-components/video";
import DownloadNoCircleSvgComponent from "../../../assets/svg-components/download-nocircle";
import NewWindowSvgComponent from "../../../assets/svg-components/new-window";
import SupportSvgComponent from "../../../assets/svg-components/support";
import ReactTooltip from "react-tooltip";


interface ICheckpointActiveProps {}

const SupportOpen: React.FunctionComponent<ICheckpointActiveProps> = (
  props: any
) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0) {
      getData();
      getUserGuideData();
    }
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0) {
      getData();
      getUserGuideData();

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      user_type: "VENDOR",
      support_status: "OPEN",
    };
    let queryRequest = QueryRequestHelper(payload);

    try {
      setIsLoading(true);
      let resp = await getSupportList(queryRequest);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setIsLoading(false);
        setList(
          getValue(resp, `data.supports`, []).map((item: object) => ({
            ...item,
            support_status: formatText(getValue(item, `support_status`, "")),
            module: formatText(getValue(item, `module`, "")),
            severity: formatText(getValue(item, `severity`, "")),
            user_type: formatText(getValue(item, `user_type`, "")),
            description: concatString(getValue(item, `description`, ""), 400),
            ticket_title: concatString(getValue(item, `ticket_title`, ""), 300),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [userGuideList, setUserGuideList] = useState([]);
  const getUserGuideData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    try {
      let payload = {
        // page_no: params.page_no ? parseInt(params.page_no) : 1,
        // page_size: params.limit ? parseInt(params.limit) : limit,
        // search_text: params.search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getUserGuideList(queryRequest);
      if (resp) {
        setUserGuideList(getValue(resp, `data.user_guides`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleChangeActiveStatus = async () => {
    // try {
    //   let resp = await adminUpdateBulkStatusCheckpoint({
    //     ids: selectedIDs,
    //     is_active: false,
    //   });
    //   if (resp) {
    //     toast.success(getValue(resp, `message`, ""));
    //     setSelectedIDs([]);
    //     getData();
    //   }
    // } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);

    let payload: any = {
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    // try {
    //   let resp = await adminDeleteSpecificCheckpoint(deleteId);
    //   if (resp) {
    //     toast.success(getValue(resp, `message`, ""));
    //     handleDelete();
    //     getData();
    //   }
    // } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.status = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/support/details/${id}`);
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Ticket Number",
        accessor: "ticket_number",
        width: 100,
        Cell: ({ row }: any) => {
          return (
            <NavLink to={`/support/open/details/${row.original.id}`}>
              {row.values.ticket_number}
            </NavLink>
          );
        },
      },
      {
        Header: "Ticket Title",
        accessor: "ticket_title",
        width: 350,
      },
      {
        Header: "Description",
        accessor: "description",
        width: 450,
      },
      {
        Header: "Severity",
        accessor: "severity",
        width: 100,
      },
      {
        Header: "Support Status",
        accessor: "support_status",
        width: 100,
      },
      {
        Header: "Module",
        accessor: "module",
        width: 100,
      },
      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			<>
      // 				<Button
      // 					color="primary"
      // 					onClick={() => handleEdit(row.original.id)}
      // 				>
      // 					Edit
      // 				</Button>
      // 				&nbsp;&nbsp;&nbsp;
      // 				<Button
      // 					color="danger"
      // 					onClick={() =>
      // 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
      // 					}
      // 				>
      // 					Delete
      // 				</Button>
      // 			</>
      // 		);
      // 	},
      // },
    ],
    []
  );
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {},
      };
    }
    return {};
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const rowClick = (obj: object) => {
    navigate(`/support/open/details/${getValue(obj, `original.id`, "")}`);
  };
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  /* -------------------------------------------------------------------------- */
  /*                                Add Popup section                           */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);

  const [request, setRequest] = useState({
    module: "REPORTS",
    severity: "HIGH",
    ticket_title: "",
    description: "",
  });

  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleChangeRequest = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: value,
    });
  };

  const handleChangeSelect = (e: any, name: string) => {
    setRequest({
      ...request,
      [name]: e.value,
    });
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  let [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        let payload = request;
        setSubmitLoading(true);
        let resp = await createSupportTicket(payload);
        if (resp) {
          setSubmitLoading(false);
          toast.success(getValue(resp, `message`, ""));
          reset();
          handleModal();
          getData();
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  const reset = () => {
    setRequest({
      ...request,
      module: "REPORTS",
      severity: "HIGH",
      ticket_title: "",
      description: "",
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    let payload: any = {
      report_type: "SUPPORT",
      report_name: `support_report_${currentDate()}`,
      user_type: "VENDOR",
      support_status: "OPEN",
      is_report: "true",
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await exportSupport({
        ...payload,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/SUPPORT`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle1 = () => setDropdownOpen((prevState) => !prevState);
  const handleNavigateSupport = () => {
    navigate(`/support/open`);
  };

  return (
    <DashboardLayout>
      <>
        {getValue(selectedIDs, `length`, 0) > 0 && (
          <NavigationBar
            selectedIDs={selectedIDs}
            isMarkInactiveSectionVisible={true}
            handleChangeActiveStatus={handleChangeActiveStatus}
            text={"MARK INACTIVE"}
          />
        )}
        <div className="dashboard-wrapper__header">
          <h4 className="dashbaord-wrapper__header-title">Support</h4>
        </div>

        <div className="admin-wrapper position-relative">
          <div className="admin-wrapper position-relative">
            <div className="d-flex">
              <SearchHeader
                route={"/support/open/add"}
                isAdd={true}
                handleAddFun={handleModal}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                isBulkUploadVisible={false}
                smartFilter={false}
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                isFilterVisible={false}
                //download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
              />

              {getValue(userGuideList, `length`, 0) > 0 && (
                <>
                 <ReactTooltip id="subHeaderUG" effect="solid" place="bottom">
                    User Guid
                </ReactTooltip>

                <div className="support-dropdown border-bottom" style={{marginLeft: "-20px", marginTop:"12px"}}
                  data-tip
                  data-for="subHeaderUG"
                >
                  <Dropdown isOpen={dropdownOpen} toggle={toggle1}>
                    <DropdownToggle
                      className="p-0 support-dd-button"
                      data-tip
                      data-for="subHeaderSupport"
                    >
                      <div className="header__dropdown m-0 sub-header-icons-holder">
                        <div className="d-flex cursor-pointer justify-content-center icons-btn w-auto px-3" 
                          style={{color: "#5f6368"}}
                        >
                         UserGuide
                        </div>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      <div className="support-dropdown-item-header">
                        <p>User Guid</p>
                        <span onClick={toggle1} className="close-svg">
                          <img src="/images/close-black.svg" width={`18px`} />
                        </span>
                      </div>

                      <div className="support-list-holder">
                        {getValue(userGuideList, `length`, 0) > 0 &&
                          userGuideList.map((item: object) => {
                            return (
                              <DropdownItem
                                className="support-dropdown-item"
                                onClick={() => {
                                  getValue(item, `type`, "") === "document"
                                    ? handleDownloadOnClick(
                                        getValue(item, `document.url`, ""),
                                        getValue(item, `document.name`, "")
                                      )
                                    : window.open(
                                        getValue(item, `video_url`, "")
                                      );
                                }}
                              >
                                <div className="d-flex align-items-center ">
                                  {getValue(item, `type`, "") === "document" ? (
                                    <DocumentSvgComponent />
                                  ) : (
                                    <VideoSvgComponent />
                                  )}

                                  <div className="support-list-name ms-2">
                                    {concatString(
                                      getValue(item, `name`, ""),
                                      25
                                    )}
                                  </div>
                                  <span className="redirect-color">
                                    {getValue(item, `type`, "") ===
                                    "document" ? (
                                      <DownloadNoCircleSvgComponent size={18} />
                                    ) : (
                                      <NewWindowSvgComponent />
                                    )}
                                    {/* <NewWindowSvgComponent /> */}
                                  </span>
                                </div>
                              </DropdownItem>
                            );
                          })}
                      </div>
                      <div className="contact-us-wrap">
                        <div className="contact-title contact-color">
                          Contact us
                        </div>
                        <div
                          className="verify-support contact-color"
                          onClick={handleNavigateSupport}
                        >
                          Verify Support Request
                        </div>
                      </div>
                    </DropdownMenu>
                  </Dropdown>
                </div>
                </>
              )}
            </div>
          </div>

          {isLoading ? (
            <Loader />
          ) : getValue(list, `length`, 0) > 0 ? (
            <ScrollableReactTable
              columns={columns}
              data={list}
              getTableState={getTableState}
              rowClick={rowClick}
              check={check}
              selectedIDs={selectedIDs}
              checkboxlogo
              getTrProps={getTrProps}
            />
          ) : (
            <>
              {getValue(list, `length`, 0) !== 0 ? (
                <>
                  <Notfound />
                </>
              ) : (
                <Notfound />
              )}
            </>
          )}
        </div>
        <div className="d-flex justify-content-between">
          {getValue(list, `length`, 0) > 0 && (
            <img
              src="/images/profile-illustration.svg"
              className="img-fluid px-5 py-3"
            />
          )}
          {totalCount > 10 ? (
            <PaginationPage
              totalCount={totalCount}
              limit={limit}
              pageNumber={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          ) : (
            <p className="show-rows-count mt-3 d-flex">
              Total Count:&nbsp;&nbsp;{" "}
              <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
            </p>
          )}
        </div>
        <DeleteModal
          isOpen={isDelete}
          handleModal={handleDelete}
          handleSubmit={handleDeleteFunction}
          deleteValue={deleteValue}
        />
        <SupportAddPopup
          isOpen={isOpen}
          handleModal={handleModal}
          handleChangeRequest={handleChangeRequest}
          request={request}
          simpleValidator={simpleValidator}
          handleChangeSelect={handleChangeSelect}
          submitLoading={submitLoading}
          handleSubmit={handleSubmit}
        />
      </>
    </DashboardLayout>
  );
};

export default SupportOpen;
